import ko from 'knockout';

import {HICAPS} from 'base/search.js';
import events from 'directory/widget/events.js';
import NameSearchManager from 'directory/widget/name_search_manager.js';
import query from 'directory/widget/query.js';

(async function() {
    await events.ready();

    const elem = document.getElementById('name');
    let nameSearchArgs = null;
    const {filter} = query.parse();
    if (filter === HICAPS) {
        nameSearchArgs = {filter};
    }
    const manager = new NameSearchManager(nameSearchArgs, elem);
    ko.applyBindings(manager, elem);
})();
